import React, {Fragment } from "react";
import { Button, Dialog, DialogContent, DialogTitle,Paper,Typography } from "@mui/material";
import { AttachMoney } from "@mui/icons-material";
import { DataGridPro } from "@mui/x-data-grid-pro";


const BillingDialog = ({open, onCancel, onAccept, liquidations}) => {

    const columns = [
        {
            field: 'id',
            headerName: 'Id',
            width: 30,
            sortable: false,
            type: 'number'
        },
        {
            field: 'customer',
            headerName: 'Cliente',
            sortable: false,
            type: 'string',
            renderCell:(params)=> `${params.row.customer.code} ${params.row.customer.name}`,
            flex:1
        },
        {
            field: 'ammount_balance',
            headerName: 'Total',
            sortable: false,
            type: 'money',
            flex:1
        }
    ];

    return(
        <Dialog
            open={open}
            fullWidth
        >
            <DialogTitle>
            <Typography variant="h4">Atencion</Typography>
            </DialogTitle>
            <DialogContent>
                <Paper className="column-container" style={{height:'20em',padding:'2em'}}>
                    
                    {
                        !liquidations?.filter(l=>l.status === 'pending').length && 
                        <Typography variant="h6">No se seleccionaron liquidaciones facturables.</Typography>
                    }

                    {
                        liquidations?.filter(l=>l.status === 'pending').length > 0 && 
                        <Fragment>

                            <Typography variant="h6">Se enviaran a facturar las siguientes liquidaciones</Typography>

                            <DataGridPro
                            rows={liquidations.filter(l=>l.status === 'pending')}
                            columns={columns}
                            headerHeight={30}
                            rowHeight={30}
                            disableColumnMenu
                            disableColumnSelector
                            disableMultipleColumnsSorting
                            hideFooter
                            sx={{marginTop:'0.5em'}}
                            />
                        </Fragment>
                    }


                </Paper>

                <div className="row-container" style={{marginTop:'2em'}}>
                    <div className="grow"></div>
                    <Button 
                        onClick={()=>onCancel()} 
                        sx={{marginRight:'1em'}}
                        variant="outlined"
                        disabled
                    >CANCELAR</Button>
                    
                    <Button 
                        onClick={()=>onAccept()} 
                        startIcon={<AttachMoney/>}
                        color="secondary"
                        variant="contained"
                        disabled={!liquidations?.filter(l=>l.status === 'pending').length}
                    >FACTURAR</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default BillingDialog;